import axios from './api.js'
import saveAs from 'file-saver'

const state = {
  // Icons
  iconsPath: [],
  iconsSelected: false,

  // Modal
  showProjectModal: false,
  showSaveModal: false,
  showPdfModal: false,

  // Wheels
  wheelVisible: false,

  // Book
  enableBookPageTurn: true,
  bookGoal: null,
  turnedPage: {
    old: 0,
    new: 0
  },

  // Version
  version: 1,

  // SelectedLanguage
  language: 'en',

  // Project
  project: {
    author: null,
    name: null,
    description: null,
    dateCreated: null,
    lastSaved: null,
    version: null,
    language: '',
    scenarios: [
      {
        name: 'scenarie 1',
        goals: [],
        selected: true
      }
    ]
  },

  // Scenarios
  scenarios: [],
  selectedScenario: [],

  // Goals
  goalList: [],
  selectedGoals: [],
  unSelectedGoals: [],
  activeGoal: {},

  // Targets
  targetList: [],
  editMode: null,

  // current state
  currentState: null,

  // make PDF
  createPDF: false
}

const getters = {
  getGoalList: state => {
    return state.goalList
  },
  getTargetList: state => {
    return state.targetList
  },
  getIconsPath: state => {
    return state.iconsPath
  },
  getIconsSelected: state => {
    return state.iconsSelected
  },
  getTurnedPage: state => {
    return state.turnedPage
  },
  getActiveGoal: state => {
    return state.activeGoal
  },
  getEditMode: state => {
    return state.editMode
  },
  getWheelVisible: state => {
    return state.wheelVisible
  },
  getLanguage: state => {
    return state.language
  },
  getProject: state => {
    return state.project
  },
  getSelectedScenario: state => {
    return state.selectedScenario
  },
  getSelectedGoals: state => {
    return state.selectedGoals
  },
  getBookGoal: state => {
    return state.bookGoal
  },
  getUnSelectedGoals: state => {
    return state.unSelectedGoals
  },
  getShowProjectModal: state => {
    return state.showProjectModal
  },
  getShowSaveModal: state => {
    return state.showSaveModal
  },
  getShowPdfModal: state => {
    return state.showPdfModal
  },
  getCurrentState: state => {
    return state.currentState
  },
  getCreatePDF: state => {
    return state.createPDF
  },
  getEnableBookPageTurn: state => {
    return state.enableBookPageTurn
  }
}

const mutations = {
  setGoalList: (state, payload) => {
    state.goalList = payload
  },
  setTargetList: (state, payload) => {
    state.targetList = payload
  },
  setIconsPath: (state) => {
    let paths = []

    for (let i = 1; i <= 17; i++) {
      paths.push('/img/icons/sdg/' + state.language + '/SDG-' + i + '.svg')
    }

    state.iconsPath = paths
  },
  setIconsSelected: (state, payload) => {
    state.iconsSelected = payload
  },
  setWheelVisible: (state, payload) => {
    state.wheelVisible = payload
  },
  setLanguage: (state, payload) => {
    state.language = payload
  },
  setProject: (state, payload) => {
    // If existing project
    if (payload.scenarios) {
      // SKAL FIXES
      // if (payload.scenarios[0].goals && payload.scenarios[0].goals.length > 0) {
      //   payload.scenarios[0].goals.forEach(goal => {
      //     goal.selected = true
      //   })
      // }
      state.project = payload
    } else {
      state.project.author = payload.author
      state.project.name = payload.name
      state.project.description = payload.description
      state.project.language = payload.language
      state.language = payload.language
      state.project.version = state.version
    }

    state.selectedScenario = state.project.scenarios[0]
    state.selectedScenario.selected = true
  },
  setSelectedGoals: (state, payload) => {
    let goalExist = false
    state.selectedGoals = []

    if (state.selectedScenario.goals.length > 0) {
      for (let j = 0; j < state.selectedScenario.goals.length; j++) {
        if (state.selectedScenario.goals[j].code === payload) {
          goalExist = true
          state.selectedScenario.goals[j].selected = !state.selectedScenario.goals[j].selected
          break
        }
      }
      if (!goalExist) {
        state.selectedScenario.goals.push({ code: payload, selected: true, targets: [] })
      }
    } else {
      state.selectedScenario.goals.push({ code: payload, selected: true, targets: [] })
    }

    if (state.enableBookPageTurn) {
      state.bookGoal = payload
    }

    for (let i = 0; i < state.selectedScenario.goals.length; i++) {
      if (state.selectedScenario.goals[i].selected) {
        state.selectedGoals.push(state.selectedScenario.goals[i].code)
      }
    }
  },
  setUnselectedGoals: (state) => {
    state.unSelectedGoals = []
    for (let i = 1; i <= 17; i++) {
      if (state.selectedGoals.indexOf(i) === -1) {
        state.unSelectedGoals.push(i)
      }
    }
  },
  setTurnedPage: (state, payload) => {
    state.turnedPage.old = Number(state.turnedPage.new)
    state.turnedPage.new = Number(payload)
  },
  setSelectedTargets: (state, payload) => {
    for (let i = 0, n = state.activeGoal.targets.length; i < n; i++) {
      if (state.activeGoal.targets[i].code === payload.code) {
        state.activeGoal.targets[i].action = payload.action
        state.activeGoal.targets[i].indicator = payload.indicator
        state.activeGoal.targets[i].effect = payload.effect || 0
        state.activeGoal.targets[i].selected = !state.editMode ? !payload.selected : payload.selected
        break
      }
    }
  },
  setActiveGoal: (state, payload) => {
    state.editMode = false
    let officialTargets = []
    let projectTargets = []

    // Active goal selected
    for (let i = 0, n = state.selectedScenario.goals.length; i < n; i++) {
      if (Number(state.selectedScenario.goals[i].code) === Number(payload)) {
        state.activeGoal = state.selectedScenario.goals[i]
        break
      }
    }

    if (state.activeGoal.targets) {
      // Populate official target lists
      state.targetList.forEach(officialTarget => {
        if (state.activeGoal.code === Number(officialTarget.goalCode)) {
          let targetObj = {
            action: null,
            indicator: null,
            effect: 0,
            displayCode: null,
            selected: false,
            code: null,
            description: null,
            goalCode: null
          }

          for (let key in targetObj) {
            targetObj[key] = officialTarget[key] || targetObj[key]
          }

          officialTargets.push(targetObj)
        }
      })

      // Populate project target lists
      state.activeGoal.targets.forEach(projectTarget => {
        let targetObj = {
          action: null,
          indicator: null,
          effect: 0,
          displayCode: null,
          selected: false,
          code: null,
          description: null,
          goalCode: null
        }

        for (let key in targetObj) {
          targetObj[key] = projectTarget[key] || targetObj[key]
          targetObj.selected = projectTarget.selected === undefined ? true : targetObj.selected
          targetObj.action = projectTarget.action === '' ? '' : targetObj.action
          targetObj.indicator = projectTarget.indicator === '' ? '' : targetObj.indicator
        }

        projectTargets.push(targetObj)
      })

      // Merge into project target list
      if (projectTargets.length > 0) {
        projectTargets.forEach(projectTarget => {
          officialTargets.forEach(officialTarget => {
            if (projectTarget.code === officialTarget.code) {
              projectTarget.description = officialTarget.description
              projectTarget.displayCode = officialTarget.displayCode
              projectTarget.goalCode = officialTarget.goalCode
            } else if (projectTargets.filter(target => target.code === officialTarget.code).length < 1) {
              projectTargets.push(officialTarget)
            }
          })
        })

        state.activeGoal.targets = projectTargets.filter(target => Number(target.goalCode) === Number(state.activeGoal.code))
      } else {
        state.activeGoal.targets = officialTargets.filter(target => Number(target.goalCode) === Number(state.activeGoal.code))
      }
      state.selectedScenario.goals.sort(function (a, b) {
        let goalA = Number(a.code)
        let goalB = Number(b.code)

        if (goalA < goalB) {
          return -1
        }

        if (goalA > goalB) {
          return 1
        }
      })

      return 0
    }
  },
  setEditMode: (state, payload) => {
    state.editMode = payload
  },
  setShowProjectModal: (state, payload) => {
    state.showProjectModal = payload
  },
  setShowSaveModal: (state, payload) => {
    state.showSaveModal = payload
  },
  setShowPdfModal: (state, payload) => {
    state.showPdfModal = payload
  },
  setClearProject: (state) => {
    Object.keys(state.project).forEach(key => {
      state.project[key] = null
    })

    state.project.scenarios = [
      {
        name: 'scenarie 1',
        goals: [],
        selected: true
      }
    ]

    state.selectedGoals = []
    state.unSelectedGoals = []
    state.project.version = state.version
    // window.location.reload()
  },
  setProjectTimestamps: (state, payload) => {
    if (!state.project.dateCreated) {
      state.project.dateCreated = payload.dateCreated
    }

    state.project.lastSaved = payload.lastSaved
  },
  setEnableBookPageTurn: (state, payload) => {
    state.enableBookPageTurn = payload
  },
  setEmptyProjectInput: (state) => {
    state.selectedScenario.goals.forEach(goals => {
      goals.targets.forEach(target => {
        if (target.selected) {
          target.action = target.action !== null ? target.action.trim() : ''
          target.indicator = target.indicator !== null ? target.indicator.trim() : ''
        }
      })
    })
  },
  setCurrentState: (state, payload) => {
    state.currentState = payload
  },
  setCreatePDF: (state, payload) => {
    state.createPDF = payload
  }
}

const actions = {
  setWheelVisible: ({ commit }, visible) => {
    commit('setWheelVisible', visible)
  },
  setProject: ({ commit }, project) => {
    state.enableBookPageTurn = false

    commit('setProject', project)
  },
  setLanguage: ({ commit }, language) => {
    commit('setLanguage', language)
  },
  setEnableBookPageTurn: ({ commit }, enabled) => {
    commit('setEnableBookPageTurn', enabled)
  },
  setIconsPath: ({ commit }) => {
    commit('setIconsPath')
  },
  setIconsSelected: ({ commit }) => {
    commit('setIconsSelected')
  },
  setGoalList: ({ commit }) => {
    return axios.get('/Public/GetGoalList', { language: state.language }).then((response) => {
      commit('setGoalList', response.data)
    }, (response) => {
      // commit('errorHandler', response)
    })
  },
  setSelectedGoals: ({ commit }, goalId) => {
    commit('setSelectedGoals', goalId)
  },
  setTurnedPage: ({ commit }, page) => {
    return new Promise((resolve, reject) => {
      resolve(commit('setTurnedPage', page))
      return true
    })
  },
  setTargetList: ({ commit }, selectedGoalCode) => {
    return axios.get('/Public/GetTargetList', { language: state.language, GoalCode: selectedGoalCode }).then((response) => {
      commit('setTargetList', response.data)
      for (let i = state.goalList.length - 1; i >= 0; i--) {
        commit('setActiveGoal', state.goalList[i].code)
      }

      commit('setUnselectedGoals')
    }, (response) => {
    })
  },
  setActiveGoal: ({ commit }, goalCode) => {
    commit('setActiveGoal', goalCode)
    commit('setUnselectedGoals')
  },
  setEditMode: ({ commit }, editMode) => {
    commit('setEditMode', editMode)

    state.activeGoal.targets.forEach(target => {
      if (target.selected && target.action === null) {
        target.action = ''
      }
    })
    // state.activeGoal.targets.forEach(target => {
    //   if (target.selected && target.indicator === null) {
    //     target.action = ''

    //     return axios.get('/Public/GetIndicatorList', { language: state.language, GoalCode: state.activeGoal.code, TargetCode: target.code }).then((response) => {
    //       for (let i = 0, n = response.data.length; i < n; i++) {
    //         if (i === 0) {
    //           target.indicator = response.data[i].description
    //         } else {
    //           target.indicator += '\n' + '\n' + response.data[i].description
    //         }
    //       }
    //       commit('setSelectedTargets', target)
    //     }, (response) => {
    //       // commit('errorHandler', response)
    //     })
    //   }
    // })
  },
  setSelectedTargets: ({ commit }, selectedTarget) => {
    commit('setSelectedTargets', selectedTarget)

    state.activeGoal.targets.forEach(target => {
      if (selectedTarget.code === target.code && target.selected && target.indicator === null) {
        // target.action = ''
        return axios.get('/Public/GetIndicatorList', { language: state.language, GoalCode: state.activeGoal.code, TargetCode: target.code }).then((response) => {
          for (let i = 0, n = response.data.length; i < n; i++) {
            if (i === 0) {
              target.indicator = response.data[i].description
            } else {
              target.indicator += '\n' + '\n' + response.data[i].description
            }
          }
          // commit('setSelectedTargets', target)
        }, (response) => {
          // commit('errorHandler', response)
        })
      }
    })
  },
  setEmptyProjectInput ({ commit }) {
    commit('setEmptyProjectInput')
  },
  setShowProjectModal: ({ commit }, showModal) => {
    commit('setShowProjectModal', showModal)
  },
  setShowSaveModal: ({ commit }, showModal) => {
    commit('setShowSaveModal', showModal)
  },
  setShowPdfModal: ({ commit }, showModal) => {
    commit('setShowPdfModal', showModal)
  },
  setClearProject: ({ commit }) => {
    commit('setClearProject')
  },
  setProjectTimestamps: ({ commit }, timestamps) => {
    commit('setProjectTimestamps', timestamps)
  },
  async setPDF ({ commit }, svg) {
    let project = {
      author: state.project.author,
      description: state.project.description,
      name: state.project.name,
      scenarios: state.project.scenarios.map(scenario => {
        return {
          goals: scenario.goals.filter(goal => goal.selected).map(goal => {
            return {
              code: goal.code,
              targets: goal.targets.filter(target => target.selected).map(target => {
                return {
                  code: target.code,
                  action: target.action,
                  indicator: target.indicator,
                  effect: target.effect
                }
              })
            }
          })
        }
      })
    }

    let baseUrl = window.location.href

    try {
      const response = await axios.post('/Public/CreateResultPdf', { baseUrl: baseUrl, language: state.language, projectJson: JSON.stringify(project), resultWheelSvg: svg })
      if (response) {
        try {
          const responseStream = await axios.getPDF('/Public/GetResultPdfStream', { id: response.data.id, FileName: state.project.name })
          if (responseStream) {
            let blob = new Blob([responseStream.data])
            saveAs(blob, state.project.name + '.pdf')
          }
        } catch (err) {
          throw err
        }
      }
    } catch (err) {
      throw err
    }
  },
  setCurrentState: ({ commit }, currentState) => {
    commit('setCurrentState', currentState)
  },
  setCreatePDF: ({ commit }, boolean) => {
    commit('setCreatePDF', boolean)
  },
  async setSignUpForMailingList ({ commit }, mail) {
    try {
      const response = await axios.post('/Public/SignUpForMailingList?Email=' + mail)
      return response
    } catch (err) {
      if (err.response.data.ErrorCode) {
        throw new Error(err.response.data.ErrorCode)
      } else {
        throw new Error(err)
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
